import React from "react";
import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";

export const BookAuthorsListFilters = React.memo(() => {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="search"
          label={translate("book_contributor_admin.filters.search")}
        />
      </Grid>
    </Grid>
  );
});
